import React from 'react';
import { Link } from 'react-router-dom';
import './CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <div className="cookie-policy-page">
      <div className="cookie-policy-container">
        <div className="cookie-policy-header">
          <Link to="/" className="back-link">← Back to Home</Link>
          <h1 className="cookie-policy-title">Cookie Policy</h1>
          <p className="cookie-policy-last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>

        <div className="cookie-policy-content">
          <p className="cookie-policy-intro">
            This Cookie Policy explains how LearnFi (Pvt) Ltd (PV 00325492) ("LearnFi Business", "LearnFi", "we", "us", "our") uses cookies and similar tracking technologies on our website. By using our website, you consent to the use of cookies as described in this policy.
          </p>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">What Are Cookies?</h2>
            <p className="cookie-policy-text">
              Cookies are small text files that are placed on your device (computer, tablet, or mobile) when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.
            </p>
            <p className="cookie-policy-text">
              Cookies allow a website to recognize your device and store some information about your preferences or past actions. This helps improve your browsing experience and allows websites to provide personalized content.
            </p>
          </section>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">Types of Cookies We Use</h2>
            
            <h3 className="cookie-policy-subsection-title">1. Necessary Cookies</h3>
            <p className="cookie-policy-text">
              These cookies are essential for the website to function properly. They enable core functionality such as security, network management, and accessibility. You cannot opt-out of these cookies as they are required for the website to work.
            </p>
            <ul className="cookie-policy-list">
              <li><strong>Purpose:</strong> Security, authentication, and site functionality</li>
              <li><strong>Duration:</strong> Session cookies (deleted when you close your browser) or persistent cookies (stored until expiration)</li>
            </ul>

            <h3 className="cookie-policy-subsection-title">2. Analytics Cookies</h3>
            <p className="cookie-policy-text">
              These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website's performance and user experience.
            </p>
            <ul className="cookie-policy-list">
              <li><strong>Purpose:</strong> Website analytics, performance monitoring, and user behavior analysis</li>
              <li><strong>Examples:</strong> Google Analytics, page views, session duration, bounce rates</li>
              <li><strong>Duration:</strong> Typically 1-2 years</li>
            </ul>

            <h3 className="cookie-policy-subsection-title">3. Marketing Cookies</h3>
            <p className="cookie-policy-text">
              These cookies are used to track visitors across websites to display relevant advertisements and measure the effectiveness of marketing campaigns.
            </p>
            <ul className="cookie-policy-list">
              <li><strong>Purpose:</strong> Advertising, retargeting, and marketing campaign effectiveness</li>
              <li><strong>Examples:</strong> Facebook Pixel, LinkedIn Insight Tag, advertising networks</li>
              <li><strong>Duration:</strong> Typically 30 days to 1 year</li>
            </ul>

            <h3 className="cookie-policy-subsection-title">4. Functional Cookies</h3>
            <p className="cookie-policy-text">
              These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings.
            </p>
            <ul className="cookie-policy-list">
              <li><strong>Purpose:</strong> Remembering user preferences, language settings, and personalized features</li>
              <li><strong>Duration:</strong> Typically 30 days to 1 year</li>
            </ul>
          </section>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">Third-Party Cookies</h2>
            <p className="cookie-policy-text">
              In addition to our own cookies, we may also use various third-party cookies to report usage statistics, deliver advertisements, and provide enhanced functionality:
            </p>
            <ul className="cookie-policy-list">
              <li><strong>Google Analytics:</strong> Website analytics and performance tracking</li>
              <li><strong>Social Media Platforms:</strong> Facebook, LinkedIn, Instagram, and other social media tracking pixels</li>
              <li><strong>Advertising Networks:</strong> Third-party advertising and retargeting services</li>
            </ul>
            <p className="cookie-policy-text">
              These third-party services have their own privacy policies and cookie practices. We encourage you to review their policies.
            </p>
          </section>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">Managing Your Cookie Preferences</h2>
            <p className="cookie-policy-text">
              You have the right to accept or reject cookies. Most web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer.
            </p>
            <p className="cookie-policy-text">
              You can manage your cookie preferences through:
            </p>
            <ul className="cookie-policy-list">
              <li><strong>Cookie Banner:</strong> When you first visit our website, you'll see a cookie banner where you can accept all, reject all, or customize your preferences</li>
              <li><strong>Cookie Manager:</strong> You can access and change your cookie preferences at any time by clicking the "Cookie Settings" link in the footer or cookie banner</li>
              <li><strong>Browser Settings:</strong> You can control cookies through your browser settings. However, disabling cookies may affect website functionality</li>
            </ul>
          </section>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">Browser-Specific Instructions</h2>
            <p className="cookie-policy-text">
              To manage cookies in your browser:
            </p>
            <ul className="cookie-policy-list">
              <li><strong>Google Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
              <li><strong>Mozilla Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
              <li><strong>Microsoft Edge:</strong> Settings → Privacy, search, and services → Cookies and site permissions</li>
            </ul>
          </section>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">Do Not Track Signals</h2>
            <p className="cookie-policy-text">
              Some browsers include a "Do Not Track" (DNT) feature that signals to websites you visit that you do not want to have your online activity tracked. Currently, there is no standard for how DNT signals should be interpreted. Our website does not currently respond to DNT signals.
            </p>
          </section>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">Updates to This Policy</h2>
            <p className="cookie-policy-text">
              We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the new Cookie Policy on this page and updating the "Last Updated" date.
            </p>
            <p className="cookie-policy-text">
              Your continued use of our website after any changes indicates your acceptance of the updated Cookie Policy.
            </p>
          </section>

          <section className="cookie-policy-section">
            <h2 className="cookie-policy-section-title">Contact Us</h2>
            <p className="cookie-policy-text">
              If you have any questions about this Cookie Policy or our use of cookies, please contact us:
            </p>
            <div className="cookie-policy-contact-info">
              <p className="cookie-policy-text"><strong>LEARNFI (PVT) LTD</strong></p>
              <p className="cookie-policy-text">Colombo, Sri Lanka</p>
              <p className="cookie-policy-text">Email: support@learnfi.lk</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;

